import styled from 'styled-components';

export const Container = styled.section`
  display: flex;

  @media ${({ theme }) => theme.device.mobile} {
    justify-content: center;
    align-content: center;
  }
`;

export const Image = styled.img`
  width: calc(100% - 30px);
  object-fit: contain;
`;

export const Close = styled.img`
  position: absolute;
  top: 30px;
  right: 16px;
  width: 32px;
  cursor: pointer;

  @media ${({ theme }) => theme.device.desktop} {
    top: 16px;
  }
`;
